module.exports = __webpack_public_path__ + "static/media/study211104.00573c25.png";